const ConfigHelper = {
    GraphQlUrl: "https://trip.familytc.com/graphql",
    Auth0_ClientId: "RK87tkmsNVO7fzliMspwZuHMD5PC9BSV",
    //Auth0_RoleId: "rol_V3ZlDwLSzqZzxjXe",
    Auth0_Audience: "https://travelsment.us.auth0.com/api/v2/",
    Auth0_domain: "travelsment.us.auth0.com",
    ReactGA: "G-VXSYNEE5XH",
    email: 'info@familytc.com',
    subEmail: ['boris.stambler@yahoo.com'],
    base_url: 'https://travelsment.us.auth0.com',
    base_api: 'https://trip.travelsment.com/api',
    url: 'https://trip.familytc.com',
    title: "FamilyTC"
};

export default ConfigHelper;